import { render } from "./CreateSubCategoryModal.vue?vue&type=template&id=23d92414&scoped=true"
import script from "./CreateSubCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateSubCategoryModal.vue?vue&type=script&lang=js"

import "./CreateSubCategoryModal.vue?vue&type=style&index=0&id=23d92414&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d92414"]])

export default __exports__